import {
  arrayCopytctsywo3h7gj as arrayCopy,
  Unit_instanceat14thlj150z as Unit_instance,
  toByte4i43936u611k as toByte,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  fill3lmv1pckd4inv as fill,
  VOID7hggqo3abtya as VOID,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toShort36kaw0zjdq3ex as toShort,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  protoOf180f3jzyo7rfj as protoOf,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  charArray2ujmm1qusno00 as charArray,
  numberToChar93r9buh19yek as numberToChar,
  toLongw1zpgk99d84b as toLong,
  Long2qws0ah9gnpki as Long,
  println2shhhgwwt4c61 as println,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  numberToLong1a4cndvg6c52s as numberToLong,
  roundToInt1ue8x8yshtznx as roundToInt,
  createThis2j2avj17cvnv2 as createThis,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
class UByteArrayInt {
  constructor(data) {
    this.g13_1 = data;
  }
  toString() {
    return UByteArrayInt__toString_impl_f8qdsi(this.g13_1);
  }
  hashCode() {
    return UByteArrayInt__hashCode_impl_y17rdr(this.g13_1);
  }
  equals(other) {
    return UByteArrayInt__equals_impl_xlvwxn(this.g13_1, other);
  }
}
class Companion {
  constructor() {
    this.u13_1 = 2;
  }
}
class TypedBuffer {}
function get_size() {
  return this.y13().r13() / this.z13() | 0;
}
class Uint16Buffer {
  constructor(buffer) {
    this.x13_1 = buffer;
  }
  y13() {
    return _Uint16Buffer___get_buffer__impl__rei8ax(this.x13_1);
  }
  z13() {
    return _Uint16Buffer___get_elementSizeInBytes__impl__tcik7m(this.x13_1);
  }
  toString() {
    return Uint16Buffer__toString_impl_rxffha(this.x13_1);
  }
  hashCode() {
    return Uint16Buffer__hashCode_impl_lcipoz(this.x13_1);
  }
  equals(other) {
    return Uint16Buffer__equals_impl_u4cl2n(this.x13_1, other);
  }
}
class SimpleBytesDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.p14_1 = initialBits;
    this.q14_1 = allowGrow;
    this.r14_1 = new SimpleRingBuffer(this.p14_1);
    this.s14_1 = new Int8Array(1024);
    this.t14_1 = new Long(0, 0);
    this.u14_1 = new Long(0, 0);
  }
  w14() {
    return this.r14_1.o14_1;
  }
  x14(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.r14_1.x14(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.t14_1 = this.t14_1.r3(toLong(out));
    }
    return out;
  }
  y14(buffer, offset, size) {
    var out = this.r14_1.y14(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      tmp.u14_1 = this.u14_1.r3(toLong(out));
    }
    return out;
  }
  hashCode() {
    return this.r14_1.z14();
  }
  equals(other) {
    var tmp;
    if (other instanceof SimpleBytesDeque) {
      tmp = this.r14_1.equals(other.r14_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class SimpleChunkedByteDeque {
  constructor() {
    this.a15_1 = ArrayDeque.mk();
    this.b15_1 = 0;
    this.c15_1 = 0;
  }
  d15(data, offset, size) {
    writeFullNoCopy(this, copyOfRange(data, offset, offset + size | 0));
  }
  y14(data, offset, size) {
    if (offset < 0 || (offset + size | 0) > data.length)
      throw IndexOutOfBoundsException.fe();
    var coffset = offset;
    var pending = size;
    var readTotal = 0;
    $l$loop_0: while (pending > 0) {
      // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
      // Inline function 'korlibs.memory.SimpleChunkedByteDeque.read.<anonymous>' call
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.a15_1.g1()) {
        tmp = this.a15_1.nk();
      } else {
        tmp = null;
      }
      var tmp0_elvis_lhs = tmp;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var chunk = tmp_0;
      var availableInChunk = chunk.length - this.b15_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = pending;
      var toCopy = Math.min(availableInChunk, b);
      if (toCopy <= 0)
        break $l$loop_0;
      arraycopy(chunk, this.b15_1, data, coffset, toCopy);
      coffset = coffset + toCopy | 0;
      pending = pending - toCopy | 0;
      readTotal = readTotal + toCopy | 0;
      consumeChunkSize(chunk, this, toCopy);
    }
    return readTotal;
  }
}
class SimpleRingBuffer {
  constructor(bits) {
    this.h14_1 = bits;
    this.i14_1 = 1 << this.h14_1;
    this.j14_1 = this.i14_1 - 1 | 0;
    this.k14_1 = new Int8Array(this.i14_1);
    this.l14_1 = 0;
    this.m14_1 = 0;
    this.n14_1 = this.i14_1;
    this.o14_1 = 0;
  }
  e15() {
    return this.k14_1;
  }
  f15() {
    return this.l14_1 & this.j14_1;
  }
  g15() {
    return this.m14_1 & this.j14_1;
  }
  h15(count) {
    if (count < 0 || count > this.n14_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.a5(toString(message));
    }
    this.m14_1 = this.m14_1 + count | 0;
    this.o14_1 = this.o14_1 + count | 0;
    this.n14_1 = this.n14_1 - count | 0;
  }
  i15(count) {
    if (count < 0 || count > this.o14_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.a5(toString(message));
    }
    this.l14_1 = this.l14_1 + count | 0;
    this.o14_1 = this.o14_1 - count | 0;
    this.n14_1 = this.n14_1 + count | 0;
  }
  j15() {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.o14_1;
    var b = this.i14_1 - (this.l14_1 & this.j14_1) | 0;
    return Math.min(a, b);
  }
  k15() {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.n14_1;
    var b = this.i14_1 - (this.m14_1 & this.j14_1) | 0;
    return Math.min(a, b);
  }
  v14(consume) {
    while (consume.o14_1 > 0) {
      // Inline function 'kotlin.comparisons.minOf' call
      var a = consume.j15();
      var b = this.k15();
      var copySize = Math.min(a, b);
      arraycopy(consume.e15(), consume.f15(), this.e15(), this.g15(), copySize);
      consume.i15(copySize);
      this.h15(copySize);
    }
  }
  x14(data, offset, size) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.n14_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      // Inline function 'kotlin.comparisons.minOf' call
      var a_0 = remaining;
      var b = this.k15();
      var chunkSize = Math.min(a_0, b);
      if (chunkSize <= 0)
        break $l$loop;
      arraycopy(data, coffset, this.k14_1, this.g15(), chunkSize);
      this.h15(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  y14(data, offset, size) {
    return this.m15(this.l15(data, offset, size));
  }
  m15(size) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.o14_1;
    var toRead = Math.min(a, size);
    this.l14_1 = (this.l14_1 + toRead | 0) & this.j14_1;
    this.n14_1 = this.n14_1 + toRead | 0;
    this.o14_1 = this.o14_1 - toRead | 0;
    return toRead;
  }
  l15(data, offset, size) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.o14_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.k14_1;
    var mask = this.j14_1;
    var coffset = offset;
    var lReadPos = this.l14_1;
    $l$loop: while (true) {
      // Inline function 'kotlin.comparisons.minOf' call
      var a_0 = toRead;
      var b = this.j15();
      var toReadChunk = Math.min(a_0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      arraycopy(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  n15() {
    if (this.o14_1 <= 0)
      return -1;
    var out = this.k14_1[this.l14_1] & 255;
    this.l14_1 = (this.l14_1 + 1 | 0) & this.j14_1;
    this.o14_1 = this.o14_1 - 1 | 0;
    this.n14_1 = this.n14_1 + 1 | 0;
    return out;
  }
  o15(offset) {
    return this.k14_1[(this.l14_1 + offset | 0) & this.j14_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof SimpleRingBuffer) {
      tmp_0 = this.o14_1 === other.o14_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.memory.SimpleRingBuffer.equaler' call
        var count = this.o14_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.memory.SimpleRingBuffer.equals.<anonymous>' call
            if (!(this.o15(n) === other.o15(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.z14();
  }
  z14() {
    // Inline function 'korlibs.memory.SimpleRingBuffer.hashCoder' call
    var count = this.o14_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.memory.SimpleRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.o15(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.p15_1 = _ByteUnits___init__impl__x795am(0.0);
  }
  q15(bytes) {
    return _ByteUnits___init__impl__x795am(bytes);
  }
  r15(bytes) {
    return _ByteUnits___init__impl__x795am(bytes.g4());
  }
}
class Companion_1 {
  i13(src, srcPosBytes, dst, dstPosBytes, sizeInBytes) {
    dst.s15(dstPosBytes, sizeInBytes).set(src.s15(srcPosBytes, sizeInBytes), 0);
  }
  j13(src, srcPosBytes, dst, dstPosBytes, sizeInBytes) {
    return equalsCommon_0(this, src, srcPosBytes, dst, dstPosBytes, sizeInBytes, false);
  }
}
class Buffer {
  static t15(dataView) {
    var $this = createThis(this);
    $this.k13_1 = dataView;
    return $this;
  }
  static m13(size, direct) {
    direct = direct === VOID ? false : direct;
    return this.t15(new DataView(new ArrayBuffer(checkNBufferSize(size))));
  }
  u15() {
    return this.k13_1.byteOffset;
  }
  r13() {
    return this.k13_1.byteLength;
  }
  d14(start, end) {
    return Buffer.t15(new DataView(get_buffer(this), this.u15() + start | 0, end - start | 0));
  }
  s15(offset, size) {
    return new Uint8Array(get_buffer(this), this.k13_1.byteOffset + offset | 0, size);
  }
  l13(bufferOffset, array, arrayOffset, len, toArray) {
    var bufferSlice = new Int8Array(this.k13_1.buffer, this.k13_1.byteOffset + bufferOffset | 0, len);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var arraySlice = array.subarray(arrayOffset, arrayOffset + len | 0);
    if (toArray) {
      arraySlice.set(bufferSlice, 0);
    } else {
      bufferSlice.set(arraySlice, 0);
    }
  }
  a14(byteOffset) {
    return this.k13_1.getInt8(byteOffset);
  }
  f14(byteOffset) {
    return this.k13_1.getInt16(byteOffset, true);
  }
  t13(byteOffset) {
    return this.k13_1.getInt32(byteOffset, true);
  }
  b14(byteOffset) {
    var v0 = toLong(this.t13(byteOffset)).c4(new Long(-1, 0));
    var v1 = toLong(this.t13(byteOffset + 4 | 0)).c4(new Long(-1, 0));
    return get_isLittleEndian() ? v1.z3(32).d4(v0) : v0.z3(32).d4(v1);
  }
  o13(byteOffset) {
    return this.k13_1.getFloat32(byteOffset, true);
  }
  g14(byteOffset) {
    return this.k13_1.getInt16(byteOffset, false);
  }
  n13(byteOffset) {
    return this.k13_1.getFloat32(byteOffset, false);
  }
  c14(byteOffset, value) {
    return this.k13_1.setInt8(byteOffset, value);
  }
  w13(byteOffset, value) {
    return this.k13_1.setInt16(byteOffset, value, true);
  }
  s13(byteOffset, value) {
    return this.k13_1.setInt32(byteOffset, value, true);
  }
  q13(byteOffset, value) {
    return this.k13_1.setFloat32(byteOffset, value, true);
  }
  v13(byteOffset, value) {
    return this.k13_1.setInt16(byteOffset, value, false);
  }
  e14(byteOffset, value) {
    return this.k13_1.setInt32(byteOffset, value, false);
  }
  p13(byteOffset, value) {
    return this.k13_1.setFloat32(byteOffset, value, false);
  }
  hashCode() {
    return hashCodeCommon(Companion_instance_1, this);
  }
  g6() {
  }
  equals(other) {
    return equalsCommon(Companion_instance_1, this, other);
  }
  toString() {
    return NBuffer_toString(this);
  }
}
//endregion
function arraycopy(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_0(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function _UByteArrayInt___init__impl__xif7bu(data) {
  return data;
}
function _UByteArrayInt___get_data__impl__l2b913($this) {
  return $this;
}
function _UByteArrayInt___get_bytes__impl__pj0ilc($this) {
  return _UByteArrayInt___get_data__impl__l2b913($this);
}
function _UByteArrayInt___init__impl__xif7bu_0(size) {
  return _UByteArrayInt___init__impl__xif7bu(new Int8Array(size));
}
function _UByteArrayInt___init__impl__xif7bu_1(size, gen) {
  var tmp = 0;
  var tmp_0 = new Int8Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = toByte(gen(tmp_1));
    tmp = tmp + 1 | 0;
  }
  return _UByteArrayInt___init__impl__xif7bu(tmp_0);
}
function _UByteArrayInt___get_size__impl__bcjnte($this) {
  return _UByteArrayInt___get_data__impl__l2b913($this).length;
}
function UByteArrayInt__get_impl_px6q8a($this, index) {
  return _UByteArrayInt___get_data__impl__l2b913($this)[index] & 255;
}
function UByteArrayInt__set_impl_gn4532($this, index, value) {
  _UByteArrayInt___get_data__impl__l2b913($this)[index] = toByte(value);
}
function UByteArrayInt__set_impl_gn4532_0($this, index, value) {
  var tmp = _UByteArrayInt___get_data__impl__l2b913($this);
  // Inline function 'kotlin.UByte.toByte' call
  tmp[index] = _UByte___get_data__impl__jof9qr(value);
}
function UByteArrayInt__getOrElse_impl_f0pf72($this, index, default_0) {
  // Inline function 'kotlin.collections.getOrElse' call
  var this_0 = _UByteArrayInt___get_data__impl__l2b913($this);
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  if (0 <= index ? index <= (this_0.length - 1 | 0) : false) {
    tmp = this_0[index];
  } else {
    // Inline function 'korlibs.memory.UByteArrayInt.getOrElse.<anonymous>' call
    tmp = toByte(default_0);
  }
  return tmp & 255;
}
function UByteArrayInt__fill_impl_7vnhx3($this, value, fromIndex, toIndex) {
  return fill(_UByteArrayInt___get_data__impl__l2b913($this), toByte(value), fromIndex, toIndex);
}
function UByteArrayInt__fill$default_impl_mdydxi($this, value, fromIndex, toIndex, $super) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _UByteArrayInt___get_size__impl__bcjnte($this) : toIndex;
  var tmp;
  if ($super === VOID) {
    UByteArrayInt__fill_impl_7vnhx3($this, value, fromIndex, toIndex);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new UByteArrayInt(tmp_0)).h13.call(new UByteArrayInt($this), value, fromIndex, toIndex);
  }
  return tmp;
}
function UByteArrayInt__toString_impl_f8qdsi($this) {
  return 'UByteArrayInt(data=' + toString($this) + ')';
}
function UByteArrayInt__hashCode_impl_y17rdr($this) {
  return hashCode($this);
}
function UByteArrayInt__equals_impl_xlvwxn($this, other) {
  if (!(other instanceof UByteArrayInt))
    return false;
  var tmp0_other_with_cast = other instanceof UByteArrayInt ? other.g13_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function arraycopy_1(src, srcPos, dst, dstPos, size) {
  return arraycopy(_UByteArrayInt___get_data__impl__l2b913(src), srcPos, _UByteArrayInt___get_data__impl__l2b913(dst), dstPos, size);
}
function asByteArray(_this__u8e3s4) {
  return _UByteArrayInt___get_data__impl__l2b913(_this__u8e3s4);
}
function _UShortArrayInt___init__impl__kdofb8(data) {
  return data;
}
function _UShortArrayInt___get_data__impl__l4stnv($this) {
  return $this;
}
function _UShortArrayInt___init__impl__kdofb8_0(size) {
  return _UShortArrayInt___init__impl__kdofb8(new Int16Array(size));
}
function UShortArrayInt__get_impl_ciz20k($this, index) {
  return _UShortArrayInt___get_data__impl__l4stnv($this)[index] & 65535;
}
function UShortArrayInt__set_impl_38wgvc($this, index, value) {
  _UShortArrayInt___get_data__impl__l4stnv($this)[index] = toShort(value);
}
function indexOf(_this__u8e3s4, sub, starting) {
  starting = starting === VOID ? 0 : starting;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.memory.array_indexOf' call
    var selfSize = _this__u8e3s4.length;
    var subSize = sub.length;
    var inductionVariable = starting;
    var last = selfSize - subSize | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var eq = 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < subSize)
          $l$loop: do {
            var m = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.memory.indexOf.<anonymous>' call
            if (!(_this__u8e3s4[n + m | 0] === sub[m])) {
              break $l$loop;
            }
            eq = eq + 1 | 0;
          }
           while (inductionVariable_0 < subSize);
        if (eq === subSize) {
          tmp$ret$1 = n;
          break $l$block;
        }
      }
       while (inductionVariable < last);
    tmp$ret$1 = -1;
  }
  return tmp$ret$1;
}
function arraycopy_2(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_3(src, srcPos, dst, dstPos, size) {
  Companion_instance_1.i13(src, srcPos, dst, dstPos, size);
}
function arrayfill(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? get_size_0(array) : end;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      setUInt8(array, n, value);
    }
     while (inductionVariable < end);
}
function arrayequal(src, srcPos, dst, dstPos, size) {
  return Companion_instance_1.j13(src, srcPos, dst, dstPos, size);
}
function arraycopy_4(src, srcPos, dst, dstPos, size) {
  return arraycopy_3(_Int32Buffer___get_buffer__impl__dnrimm(src), imul(srcPos, 4), _Int32Buffer___get_buffer__impl__dnrimm(dst), imul(dstPos, 4), imul(size, 4));
}
function arraycopy_5(src, srcPos, dst, dstPos, size) {
  Uint16Buffer__setArray_impl_x4uzt(dst, dstPos, src, srcPos, size);
}
function asUShortArrayInt(_this__u8e3s4) {
  return _UShortArrayInt___init__impl__kdofb8(_this__u8e3s4);
}
function arrayadd(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? (new Uint16Buffer(array)).e1() : end;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      Uint16Buffer__set_impl_g0kliu(array, n, Uint16Buffer__get_impl_6qi0dm(array, n) + value | 0);
    }
     while (inductionVariable < end);
}
function arrayfill_0(array, value, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? array.length : end;
  return fill(array, value, start, end);
}
function arraycopy_6(src, srcPos, dst, dstPos, size) {
  dst.l13(dstPos, src, srcPos, size, false);
}
function arraycopy_7(src, srcPos, dst, dstPos, size) {
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = srcPos + size | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = src;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
}
function arraycopy_8(src, srcPos, dst, dstPos, size) {
  Int8Buffer__setArray_impl_oimleb(dst, dstPos, src, srcPos, size);
}
function arraycopy_9(src, srcPos, dst, dstPos, size) {
  Float32Buffer__setArray_impl_eosj51(dst, dstPos, src, srcPos, size);
}
function arraycopy_10(src, srcPos, dst, dstPos, size) {
  Int32Buffer__setArray_impl_eeeiw8(dst, dstPos, src, srcPos, size);
}
function _Float32Buffer___init__impl__403k2m(buffer) {
  return buffer;
}
function _Float32Buffer___get_buffer__impl__x5nu9x($this) {
  return $this;
}
function _Float32Buffer___init__impl__403k2m_0(data, offset, size) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? data.length - offset | 0 : size;
  // Inline function 'kotlin.also' call
  var this_0 = Buffer.m13(imul(size, 4));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.Float32Buffer.<init>.<anonymous>' call
  setArray(this_0, 0, data, offset, size);
  return _Float32Buffer___init__impl__403k2m(this_0);
}
function Float32Buffer__get_impl_659lhu($this, index) {
  // Inline function 'korlibs.memory.getF32' call
  var this_0 = _Float32Buffer___get_buffer__impl__x5nu9x($this);
  var byteOffset = imul(index, 4);
  return true ? this_0.o13(byteOffset) : this_0.n13(byteOffset);
}
function Float32Buffer__set_impl_34szne($this, index, value) {
  // Inline function 'korlibs.memory.setF32' call
  var this_0 = _Float32Buffer___get_buffer__impl__x5nu9x($this);
  var byteOffset = imul(index, 4);
  var tmp;
  if (true) {
    this_0.q13(byteOffset, value);
    tmp = Unit_instance;
  } else {
    this_0.p13(byteOffset, value);
    tmp = Unit_instance;
  }
  return tmp;
}
function Float32Buffer__setArray_impl_eosj51($this, index, inp, offset, size) {
  return setArray(_Float32Buffer___get_buffer__impl__x5nu9x($this), imul(index, 4), inp, offset, size);
}
function asFloat32(_this__u8e3s4) {
  return _Float32Buffer___init__impl__403k2m(_this__u8e3s4);
}
function copyOf(_this__u8e3s4, newSize) {
  var out = Buffer.m13(newSize);
  // Inline function 'kotlin.math.min' call
  var a = _this__u8e3s4.r13();
  var tmp$ret$0 = Math.min(a, newSize);
  arraycopy_3(_this__u8e3s4, 0, out, 0, tmp$ret$0);
  return out;
}
function setArrayLE(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayLE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.s13(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setInt32(_this__u8e3s4, index, value) {
  return _this__u8e3s4.s13(imul(index, 4), value);
}
function getInt32(_this__u8e3s4, index) {
  return _this__u8e3s4.t13(imul(index, 4));
}
function allocDirect(_this__u8e3s4, size) {
  return Buffer.m13(size, true);
}
function setFloat32(_this__u8e3s4, index, value) {
  return _this__u8e3s4.q13(imul(index, 4), value);
}
function allocNoDirect(_this__u8e3s4, size) {
  return Buffer.m13(size, false);
}
function _Int32Buffer___init__impl__o98lxn(buffer) {
  return buffer;
}
function _Int32Buffer___get_buffer__impl__dnrimm($this) {
  return $this;
}
function Int32Buffer__setArray_impl_eeeiw8($this, index, inp, offset, size) {
  return setArray_0(_Int32Buffer___get_buffer__impl__dnrimm($this), imul(index, 4), inp, offset, size);
}
function get_i32(_this__u8e3s4) {
  return asInt32(_this__u8e3s4);
}
function get_size_0(_this__u8e3s4) {
  return _this__u8e3s4.r13();
}
function _Int8Buffer___init__impl__e20lvc(buffer) {
  return buffer;
}
function _Int8Buffer___get_buffer__impl__q0gulb($this) {
  return $this;
}
function _Int8Buffer___init__impl__e20lvc_0(data, offset, size) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? data.length - offset | 0 : size;
  // Inline function 'kotlin.also' call
  var this_0 = Buffer.m13(imul(size, 1));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.Int8Buffer.<init>.<anonymous>' call
  setArray_1(this_0, 0, data, offset, size);
  return _Int8Buffer___init__impl__e20lvc(this_0);
}
function Int8Buffer__setArray_impl_oimleb($this, index, inp, offset, size) {
  return setArray_1(_Int8Buffer___get_buffer__impl__q0gulb($this), imul(index, 1), inp, offset, size);
}
function sliceWithSize(_this__u8e3s4, start, size) {
  return sliceBuffer(_this__u8e3s4, start, start + size | 0);
}
function clone(_this__u8e3s4, direct) {
  direct = direct === VOID ? false : direct;
  var out = Buffer.m13(get_size_0(_this__u8e3s4), direct);
  arraycopy_3(_this__u8e3s4, 0, out, 0, get_size_0(_this__u8e3s4));
  return out;
}
function _Uint16Buffer___init__impl__4401ya(buffer) {
  return buffer;
}
function _Uint16Buffer___get_buffer__impl__rei8ax($this) {
  return $this;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function _Uint16Buffer___get_elementSizeInBytes__impl__tcik7m($this) {
  return 2;
}
function Uint16Buffer__get_impl_6qi0dm($this, index) {
  // Inline function 'korlibs.memory.getU16' call
  var this_0 = _Uint16Buffer___get_buffer__impl__rei8ax($this);
  var byteOffset = imul(index, 2);
  return true ? getU16LE(this_0, byteOffset) : getU16BE(this_0, byteOffset);
}
function Uint16Buffer__set_impl_g0kliu($this, index, value) {
  // Inline function 'korlibs.memory.set16' call
  var this_0 = _Uint16Buffer___get_buffer__impl__rei8ax($this);
  var byteOffset = imul(index, 2);
  var value_0 = toShort(value);
  var tmp;
  if (true) {
    this_0.w13(byteOffset, value_0);
    tmp = Unit_instance;
  } else {
    this_0.v13(byteOffset, value_0);
    tmp = Unit_instance;
  }
  return tmp;
}
function Uint16Buffer__setArray_impl_x4uzt($this, index, inp, offset, size) {
  return setArray_2(_Uint16Buffer___get_buffer__impl__rei8ax($this), imul(index, 2), _UShortArrayInt___get_data__impl__l4stnv(inp), offset, size);
}
function Uint16Buffer__toString_impl_rxffha($this) {
  return 'Uint16Buffer(buffer=' + $this.toString() + ')';
}
function Uint16Buffer__hashCode_impl_lcipoz($this) {
  return $this.hashCode();
}
function Uint16Buffer__equals_impl_u4cl2n($this, other) {
  if (!(other instanceof Uint16Buffer))
    return false;
  var tmp0_other_with_cast = other instanceof Uint16Buffer ? other.x13_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function get_u16(_this__u8e3s4) {
  return asUInt16(_this__u8e3s4);
}
function get_f32(_this__u8e3s4) {
  return asFloat32(_this__u8e3s4);
}
function checkNBufferSize(size) {
  if (size < 0)
    throw IllegalArgumentException.l('invalid size ' + size);
  return size;
}
function hashCodeCommon(_this__u8e3s4, buffer) {
  var h = 1;
  var len = buffer.r13();
  var inductionVariable = 0;
  var last = len / 4 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      h = imul(31, h) + buffer.t13(imul(n, 4)) | 0;
    }
     while (inductionVariable < last);
  var offset = imul(len / 4 | 0, 4);
  var inductionVariable_0 = 0;
  var last_0 = len % 4 | 0;
  if (inductionVariable_0 < last_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      h = imul(31, h) + buffer.a14(offset + n_0 | 0) | 0;
    }
     while (inductionVariable_0 < last_0);
  return h;
}
function equalsCommon(_this__u8e3s4, that, other) {
  var tmp;
  if (!(other instanceof Buffer)) {
    tmp = true;
  } else {
    tmp = !(get_size_0(that) === get_size_0(other));
  }
  if (tmp)
    return false;
  return Companion_instance_1.j13(that, 0, other, 0, that.r13());
}
function NBuffer_toString(buffer) {
  return 'Buffer(size=' + get_size_0(buffer) + ')';
}
function equalsCommon_0(_this__u8e3s4, src, srcPosBytes, dst, dstPosBytes, sizeInBytes, use64) {
  use64 = use64 === VOID ? true : use64;
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!((srcPosBytes + sizeInBytes | 0) <= src.r13())) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.a5(toString(message));
  }
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!((dstPosBytes + sizeInBytes | 0) <= dst.r13())) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message_0 = 'Check failed.';
    throw IllegalStateException.a5(toString(message_0));
  }
  var offset = 0;
  var remaining = sizeInBytes;
  if (use64) {
    var WORD = 8;
    var words = remaining / WORD | 0;
    remaining = remaining % WORD | 0;
    var inductionVariable = 0;
    if (inductionVariable < words)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v0 = src.b14((srcPosBytes + offset | 0) + imul(n, WORD) | 0);
        var v1 = dst.b14((dstPosBytes + offset | 0) + imul(n, WORD) | 0);
        if (!v0.equals(v1)) {
          return false;
        }
      }
       while (inductionVariable < words);
    offset = offset + imul(words, WORD) | 0;
  }
  var WORD_0 = 4;
  var words_0 = remaining / WORD_0 | 0;
  remaining = remaining % WORD_0 | 0;
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < words_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var v0_0 = src.t13((srcPosBytes + offset | 0) + imul(n_0, WORD_0) | 0);
      var v1_0 = dst.t13((dstPosBytes + offset | 0) + imul(n_0, WORD_0) | 0);
      if (!(v0_0 === v1_0)) {
        return false;
      }
    }
     while (inductionVariable_0 < words_0);
  offset = offset + imul(words_0, WORD_0) | 0;
  var inductionVariable_1 = 0;
  var last = remaining;
  if (inductionVariable_1 < last)
    do {
      var n_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var v0_1 = src.a14((srcPosBytes + offset | 0) + n_1 | 0);
      var v1_1 = dst.a14((dstPosBytes + offset | 0) + n_1 | 0);
      if (!(v0_1 === v1_1)) {
        return false;
      }
    }
     while (inductionVariable_1 < last);
  return true;
}
function setUInt8(_this__u8e3s4, index, value) {
  return _this__u8e3s4.c14(index, toByte(value));
}
function setArray(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE_0(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function sliceBuffer(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.r13() : end;
  if (start > end || !(0 <= start ? start <= _this__u8e3s4.r13() : false) || !(0 <= end ? end <= _this__u8e3s4.r13() : false)) {
    throw IllegalArgumentException.l('invalid slice start:' + start + ', end:' + end + ' not in 0..' + _this__u8e3s4.r13());
  }
  return _this__u8e3s4.d14(start, end);
}
function setArray_0(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE_0(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function asInt32(_this__u8e3s4) {
  return _Int32Buffer___init__impl__o98lxn(_this__u8e3s4);
}
function setArray_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  arraycopy_6(data, start, _this__u8e3s4, byteOffset, size);
}
function setArray_2(_this__u8e3s4, byteOffset, data, start, size, littleEndian) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  if (littleEndian) {
    setArrayLE_1(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  } else {
    setArrayBE_1(_this__u8e3s4, byteOffset, data, start, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function asUInt16(_this__u8e3s4) {
  return _Uint16Buffer___init__impl__4401ya(_this__u8e3s4);
}
function setArrayLE_0(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayLE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.q13(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayBE(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayBE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.p13(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayBE_0(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayBE.<anonymous>' call
      var offset = byteOffset + imul(n, 4) | 0;
      var index = start + n | 0;
      _this__u8e3s4.e14(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayLE_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayLE.<anonymous>' call
      var offset = byteOffset + imul(n, 2) | 0;
      var index = start + n | 0;
      _this__u8e3s4.w13(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setArrayBE_1(_this__u8e3s4, byteOffset, data, start, size) {
  start = start === VOID ? 0 : start;
  size = size === VOID ? data.length - start | 0 : size;
  var inductionVariable = 0;
  var tmp;
  if (inductionVariable < size) {
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.setArrayBE.<anonymous>' call
      var offset = byteOffset + imul(n, 2) | 0;
      var index = start + n | 0;
      _this__u8e3s4.v13(offset, data[index]);
    }
     while (inductionVariable < size);
    tmp = Unit_instance;
  }
  return tmp;
}
function getU16LE(_this__u8e3s4, byteOffset) {
  return get_unsigned(_this__u8e3s4.f14(byteOffset));
}
function getU16BE(_this__u8e3s4, byteOffset) {
  return get_unsigned(_this__u8e3s4.g14(byteOffset));
}
function get_unsigned(_this__u8e3s4) {
  return _this__u8e3s4 & 65535;
}
function get_i8(_this__u8e3s4) {
  return asInt8(_this__u8e3s4);
}
function asInt8(_this__u8e3s4) {
  return _Int8Buffer___init__impl__e20lvc(_this__u8e3s4);
}
function getU16LE_0(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16LE' call
  return u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 8;
}
function getS32LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32LE' call
  return u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset + 2 | 0) << 16 | u8$accessor$t64k4t(_this__u8e3s4, offset + 3 | 0) << 24;
}
function getS32BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32BE' call
  return u8$accessor$t64k4t(_this__u8e3s4, offset + 3 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 2 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 16 | u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 24;
}
function getU16BE_0(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16BE' call
  return u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 8;
}
function getU24LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24LE' call
  return u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset + 2 | 0) << 16;
}
function getU24BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24BE' call
  return u8$accessor$t64k4t(_this__u8e3s4, offset + 2 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 16;
}
function getU16(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getU16LE_0(_this__u8e3s4, offset) : getU16BE_0(_this__u8e3s4, offset);
}
function getS32(_this__u8e3s4, offset, littleEndian) {
  return littleEndian ? getS32LE(_this__u8e3s4, offset) : getS32BE(_this__u8e3s4, offset);
}
function getU8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function getS16LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16LE' call
  var tmp$ret$0 = u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function getS24LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get24LE' call
  var tmp$ret$0 = u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset + 2 | 0) << 16;
  return signExtend(tmp$ret$0, 24);
}
function u8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset] & 255;
}
function getU32LE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get32LE' call
  var tmp$ret$0 = u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset + 2 | 0) << 16 | u8$accessor$t64k4t(_this__u8e3s4, offset + 3 | 0) << 24;
  return _get_unsigned_$accessor$t64k4t_9b8q14(tmp$ret$0);
}
function getS8(_this__u8e3s4, offset) {
  return _this__u8e3s4[offset];
}
function getS16BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get16BE' call
  var tmp$ret$0 = u8$accessor$t64k4t(_this__u8e3s4, offset + 1 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset + 0 | 0) << 8;
  return signExtend(tmp$ret$0, 16);
}
function getS64BE(_this__u8e3s4, offset) {
  // Inline function 'korlibs.memory.get64BE' call
  // Inline function 'korlibs.memory.get32BE' call
  var offset_0 = offset + 4 | 0;
  var tmp$ret$0 = u8$accessor$t64k4t(_this__u8e3s4, offset_0 + 3 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset_0 + 2 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset_0 + 1 | 0) << 16 | u8$accessor$t64k4t(_this__u8e3s4, offset_0 + 0 | 0) << 24;
  var tmp = _get_unsigned_$accessor$t64k4t_9b8q14(tmp$ret$0).z3(0);
  // Inline function 'korlibs.memory.get32BE' call
  var offset_1 = offset + 0 | 0;
  var tmp$ret$1 = u8$accessor$t64k4t(_this__u8e3s4, offset_1 + 3 | 0) << 0 | u8$accessor$t64k4t(_this__u8e3s4, offset_1 + 2 | 0) << 8 | u8$accessor$t64k4t(_this__u8e3s4, offset_1 + 1 | 0) << 16 | u8$accessor$t64k4t(_this__u8e3s4, offset_1 + 0 | 0) << 24;
  return tmp.d4(_get_unsigned_$accessor$t64k4t_9b8q14(tmp$ret$1).z3(32));
}
function getS8Array(_this__u8e3s4, offset, count) {
  return copyOfRange(_this__u8e3s4, offset, offset + count | 0);
}
function getS16ArrayBE(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = new Int16Array(count);
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.getTypedArray.<anonymous>' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.getS16ArrayBE.<anonymous>' call
      var pos = offset + imul(n, 2) | 0;
      array[n] = toShort(getS16BE(_this__u8e3s4, pos));
    }
     while (inductionVariable < count);
  return array;
}
function getU16ArrayBE(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = charArray(count);
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.getTypedArray.<anonymous>' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.getU16ArrayBE.<anonymous>' call
      var pos = offset + imul(n, 2) | 0;
      array[n] = numberToChar(getS16BE(_this__u8e3s4, pos));
    }
     while (inductionVariable < count);
  return array;
}
function getS32ArrayLE(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = new Int32Array(count);
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.getTypedArray.<anonymous>' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.getS32ArrayLE.<anonymous>' call
      var pos = offset + imul(n, 4) | 0;
      array[n] = getS32LE(_this__u8e3s4, pos);
    }
     while (inductionVariable < count);
  return array;
}
function getS32ArrayBE(_this__u8e3s4, offset, count) {
  // Inline function 'korlibs.memory.getTypedArray' call
  var array = new Int32Array(count);
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.getTypedArray.<anonymous>' call
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.memory.getS32ArrayBE.<anonymous>' call
      var pos = offset + imul(n, 4) | 0;
      array[n] = getS32BE(_this__u8e3s4, pos);
    }
     while (inductionVariable < count);
  return array;
}
function get_unsigned_0(_this__u8e3s4) {
  return toLong(_this__u8e3s4).c4(new Long(-1, 0));
}
function u8$accessor$t64k4t(_this__u8e3s4, offset) {
  return u8(_this__u8e3s4, offset);
}
function _get_unsigned_$accessor$t64k4t_9b8q14(_this__u8e3s4) {
  return get_unsigned_0(_this__u8e3s4);
}
function ensureWrite($this, count) {
  if (count <= $this.r14_1.n14_1)
    return Unit_instance;
  if (!$this.q14_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.r14_1.n14_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.a5(toString(message));
  }
  var minNewSize = $this.r14_1.o14_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new SimpleRingBuffer(ilog2(minNewSize) + 2 | 0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.memory.SimpleBytesDeque.ensureWrite.<anonymous>' call
  this_0.v14($this.r14_1);
  tmp.r14_1 = this_0;
}
function ilog2(v) {
  var tmp;
  if (v === 0) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 31 - clz32(v) | 0;
  }
  return tmp;
}
function writeFullNoCopy($this, data) {
  // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
  $this.a15_1.h(data);
  $this.c15_1 = $this.c15_1 + data.length | 0;
}
function consumeChunkSize(_this__u8e3s4, $this, size) {
  var chunk = _this__u8e3s4;
  // Inline function 'korlibs.memory.SimpleChunkedByteDeque.lock' call
  $this.b15_1 = $this.b15_1 + size | 0;
  $this.c15_1 = $this.c15_1 - size | 0;
  if ($this.b15_1 >= chunk.length) {
    $this.a15_1.rk();
    $this.b15_1 = 0;
  }
}
function signExtend(_this__u8e3s4, bits) {
  return _this__u8e3s4 << (32 - bits | 0) >> (32 - bits | 0);
}
function _ByteUnits___init__impl__x795am(bytes) {
  return bytes;
}
function _ByteUnits___get_bytes__impl__leukoc($this) {
  return $this;
}
function _ByteUnits___get_bytesLong__impl__1lc1w0($this) {
  return numberToLong(_ByteUnits___get_bytes__impl__leukoc($this));
}
function _ByteUnits___get_kiloBytes__impl__jnym6r($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / 1024.0;
}
function _ByteUnits___get_megaBytes__impl__qjjio2($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / (1024.0 * 1024.0);
}
function _ByteUnits___get_gigaBytes__impl__i7s8s8($this) {
  return _ByteUnits___get_bytes__impl__leukoc($this) / (1024.0 * 1024.0 * 1024.0);
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function roundToDigits(_this__u8e3s4, $this, digits) {
  // Inline function 'kotlin.math.pow' call
  var num = Math.pow(10.0, digits);
  return roundToInt(_this__u8e3s4 * num) / num;
}
function ByteUnits__toString_impl_ox2ku2($this) {
  return _ByteUnits___get_gigaBytes__impl__i7s8s8($this) >= 1.0 ? '' + roundToDigits(_ByteUnits___get_gigaBytes__impl__i7s8s8($this), $this, 1) + ' GB' : _ByteUnits___get_megaBytes__impl__qjjio2($this) >= 1.0 ? '' + roundToDigits(_ByteUnits___get_megaBytes__impl__qjjio2($this), $this, 1) + ' MB' : _ByteUnits___get_kiloBytes__impl__jnym6r($this) >= 1.0 ? '' + roundToDigits(_ByteUnits___get_kiloBytes__impl__jnym6r($this), $this, 1) + ' KB' : _ByteUnits___get_bytesLong__impl__1lc1w0($this).toString() + ' B';
}
function get_isLittleEndian() {
  _init_properties_Buffer_js_kt__30np2z();
  return isLittleEndian;
}
var isLittleEndian;
function asInt8Array(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int8Array(_this__u8e3s4);
}
function asInt32Array(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int32Array(_this__u8e3s4);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function get_buffer(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return _this__u8e3s4.k13_1.buffer;
}
function get_arrayUByte(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Uint8Array(get_buffer(_this__u8e3s4), _this__u8e3s4.u15(), _this__u8e3s4.r13());
}
function get_arrayInt(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Int32Array(get_buffer(_this__u8e3s4), _this__u8e3s4.u15(), _this__u8e3s4.r13() / 4 | 0);
}
function get_arrayFloat(_this__u8e3s4) {
  _init_properties_Buffer_js_kt__30np2z();
  return new Float32Array(get_buffer(_this__u8e3s4), _this__u8e3s4.u15(), _this__u8e3s4.r13() / 4 | 0);
}
var properties_initialized_Buffer_js_kt_i0s0qv;
function _init_properties_Buffer_js_kt__30np2z() {
  if (!properties_initialized_Buffer_js_kt_i0s0qv) {
    properties_initialized_Buffer_js_kt_i0s0qv = true;
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.also' call
    var this_0 = new Uint32Array(1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.memory.isLittleEndian.<anonymous>' call
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0[0] = 287454020;
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array(this_0.buffer))[0] === 68;
  }
}
//region block: post-declaration
initMetadataForClass(UByteArrayInt, 'UByteArrayInt');
initMetadataForCompanion(Companion);
initMetadataForInterface(TypedBuffer, 'TypedBuffer');
protoOf(Uint16Buffer).e1 = get_size;
initMetadataForClass(Uint16Buffer, 'Uint16Buffer', VOID, VOID, [TypedBuffer]);
initMetadataForClass(SimpleBytesDeque, 'SimpleBytesDeque', SimpleBytesDeque);
initMetadataForClass(SimpleChunkedByteDeque, 'SimpleChunkedByteDeque', SimpleChunkedByteDeque);
initMetadataForClass(SimpleRingBuffer, 'SimpleRingBuffer');
initMetadataForCompanion(Companion_0);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Buffer, 'Buffer', VOID, VOID, [AutoCloseable]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  UByteArrayInt__fill$default_impl_mdydxi as UByteArrayInt__fill$default_impl_mdydxi1wz00ttbtxw3z,
  ByteUnits__toString_impl_ox2ku2 as ByteUnits__toString_impl_ox2ku22zb4xrvk9phl9,
  _Float32Buffer___init__impl__403k2m_0 as _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef,
  _Float32Buffer___get_buffer__impl__x5nu9x as _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q,
  Float32Buffer__get_impl_659lhu as Float32Buffer__get_impl_659lhu2fcy7ilfo0o6g,
  Float32Buffer__set_impl_34szne as Float32Buffer__set_impl_34sznedf8x821xo8e0,
  _Int8Buffer___init__impl__e20lvc_0 as _Int8Buffer___init__impl__e20lvcp4p2uvfo996c,
  _Int8Buffer___get_buffer__impl__q0gulb as _Int8Buffer___get_buffer__impl__q0gulbq12sgwh1jcvh,
  _UByteArrayInt___init__impl__xif7bu as _UByteArrayInt___init__impl__xif7bu3la1vncefaitd,
  _UByteArrayInt___init__impl__xif7bu_0 as _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk,
  _UByteArrayInt___init__impl__xif7bu_1 as _UByteArrayInt___init__impl__xif7bu29rfv0s29knch,
  _UByteArrayInt___get_bytes__impl__pj0ilc as _UByteArrayInt___get_bytes__impl__pj0ilcub6wlvph43r,
  UByteArrayInt__getOrElse_impl_f0pf72 as UByteArrayInt__getOrElse_impl_f0pf7216mblxgilcglu,
  UByteArrayInt__get_impl_px6q8a as UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2,
  UByteArrayInt__set_impl_gn4532 as UByteArrayInt__set_impl_gn45323mc9aqt29pp9p,
  UByteArrayInt__set_impl_gn4532_0 as UByteArrayInt__set_impl_gn45321v79kdhd4y5qt,
  _UByteArrayInt___get_size__impl__bcjnte as _UByteArrayInt___get_size__impl__bcjnte1riayqw17gpkp,
  _UShortArrayInt___init__impl__kdofb8_0 as _UShortArrayInt___init__impl__kdofb8124zcs6bgqfxc,
  UShortArrayInt__get_impl_ciz20k as UShortArrayInt__get_impl_ciz20k3q1wtux9fkamc,
  UShortArrayInt__set_impl_38wgvc as UShortArrayInt__set_impl_38wgvc2wqa90g1ifa1l,
  Uint16Buffer__set_impl_g0kliu as Uint16Buffer__set_impl_g0kliu1ltqm2yo4vfb6,
  Companion_getInstance_0 as Companion_getInstance35xii7iw9kdg2,
  Companion_instance_1 as Companion_instancejzamqjlqqs4y,
  Buffer as Buffer25z94vsj0kb1s,
  SimpleBytesDeque as SimpleBytesDeque3uob1f4dosqej,
  SimpleChunkedByteDeque as SimpleChunkedByteDeque3cr64mogfywgm,
  SimpleRingBuffer as SimpleRingBuffer1a4k3g2va6i8y,
  UByteArrayInt as UByteArrayInt247ue4nx0pkns,
  allocDirect as allocDirecttfrgytwudkpf,
  allocNoDirect as allocNoDirect3dykranmovqsj,
  get_arrayFloat as get_arrayFloat1r0vk858s9phl,
  get_arrayInt as get_arrayInt3v8kuk47rixtz,
  get_arrayUByte as get_arrayUByte9swx7ogt2hf2,
  arrayadd as arrayadd3erpr00t9k8j,
  arraycopy as arraycopy3czrd9re36wzt,
  arraycopy_0 as arraycopy14jict0dth60o,
  arraycopy_2 as arraycopy52dxe7vhzf14,
  arraycopy_8 as arraycopyphzg5lpa6gvz,
  arraycopy_4 as arraycopyqmyo4vjwforw,
  arraycopy_10 as arraycopy1hsh296f5d0xg,
  arraycopy_1 as arraycopy3n78tfzvkl4kg,
  arraycopy_9 as arraycopy3fi6tr79d693r,
  arraycopy_3 as arraycopy3uxsqjlixmnz3,
  arraycopy_5 as arraycopy28e1us87mwypg,
  arraycopy_7 as arraycopy9a0yzbjqwnvw,
  arrayequal as arrayequal25g4om83vd8w1,
  arrayfill_0 as arrayfill1njpugsfcm512,
  arrayfill as arrayfill2iqmyqqqfwuaf,
  asByteArray as asByteArray1mw554k0vpuh5,
  asInt32Array as asInt32Arrayf0ml2lp92o3m,
  asInt8Array as asInt8Array769i4qnpoc13,
  asUShortArrayInt as asUShortArrayInt2gfk0h9rafip5,
  clone as clonelcrqoxe4ne5i,
  copyOf as copyOfnqvdm0sc8lk,
  get_f32 as get_f3218rglfhpgbhzp,
  getInt32 as getInt32gmg3zyw00v1v,
  getS16ArrayBE as getS16ArrayBE3bj6gsad0tz3k,
  getS16BE as getS16BE6c2odqehs5au,
  getS16LE as getS16LE39jsuv9u9gi4y,
  getS24LE as getS24LE1b229asvs5i3l,
  getS32ArrayBE as getS32ArrayBE30ehj217529qp,
  getS32ArrayLE as getS32ArrayLE2u84ix7qnexrb,
  getS32BE as getS32BE5aphh7sm8f2q,
  getS32LE as getS32LE1pxm9wohin3g8,
  getS32 as getS3225c4j90s7n16a,
  getS64BE as getS64BE1b3e93qe1xjxx,
  getS8Array as getS8Array1clq6jd2z5jh9,
  getS8 as getS83kqgdtkseh4fp,
  getU16ArrayBE as getU16ArrayBE1cpolqhg4wxps,
  getU16BE_0 as getU16BE2rszf3doox5o,
  getU16LE_0 as getU16LE2cizldw8qp53x,
  getU16 as getU1616fejrhhqwfv2,
  getU24BE as getU24BE36pml41y2814b,
  getU24LE as getU24LEi3x1z5ajbdbv,
  getU32LE as getU32LE1yo0ft9yyv0wa,
  getU8 as getU83agrw8yj0shar,
  get_i32 as get_i323p4hlz6j3xys8,
  get_i8 as get_i83qhdj74rhdyeg,
  indexOf as indexOf1wbggs5i7ilsw,
  setArrayLE as setArrayLEwil75hzlfusu,
  setFloat32 as setFloat323e0ukqyly1ufv,
  setInt32 as setInt32178h074gei71f,
  get_size_0 as get_size13scmefs6mbfn,
  sliceBuffer as sliceBufferpiate0wictoq,
  sliceWithSize as sliceWithSize2i7i6olf26byj,
  get_u16 as get_u163bxpdbbave1v5,
};
//endregion
